// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2bCbd","unreadBadge":"styles_unreadBadge__1zumt","modalContent":"styles_modalContent__38Jl3","modal":"styles_modal__3XpnX"};